import { Button } from '@phi/components';
import './FormButtonSelect.scss';
import { as } from '@phi/util/types';
import { defineComponent, h, PropType } from 'vue';

type Option<T> = {
    value: T;
    label: string;
}

export default <T>() => defineComponent({
    props: {
        options: {
            required: true,
            type: Array as PropType<Option<T>[]>,
        },

        value: {
            required: true,
            type: as<PropType<T | undefined>>(null),
        }
    },

    emits: {
        'update:value': (x: T) => true,
    },

    render() {
        return h('div', { class: 'form-button-select' }, [
            this.options.map((x) => h(Button, {
                variant: x.value === this.value ? 'primary' : 'outlined',
                onClick: () => this.$emit('update:value', x.value),
            }, () => x.label))
        ]);
    }
});
